module.exports = "/assets/packs/images/785bf4c17ac8c6b6a8f6869634265c2c.svg";